import{jsx as o}from"react/jsx-runtime";import t from"./assets/content-loader.module.scss";const e=()=>o("div",{className:t.contentLoader,children:"Loading"});export{e as ContentLoader};
